import { LogOut, Menu } from "lucide-react";
import { useAuth } from "@/features/auth";
import { Button } from "@/components/ui/button";
import { ThemeToggle } from "@/components/ui/theme-toggle";

interface NavbarProps {
  onToggleSidebar: () => void;
}

export function Navbar({ onToggleSidebar }: NavbarProps) {
  const { user, logout } = useAuth();

  return (
    <header className="sticky top-0 z-30 border-b border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800">
      <div className="flex h-16 items-center px-4 sm:px-6">
        {/* Left: hamburger + logo */}
        <div className="flex items-center gap-3 min-w-0 flex-1">
          <Button variant="ghost" size="icon" className="shrink-0 lg:hidden" onClick={onToggleSidebar}>
            <Menu className="h-5 w-5" />
          </Button>
          <img src="/mdkl-logo.svg" alt="MDKL" className="h-10 w-auto hidden sm:block rounded bg-white px-1.5 py-0.5" />
        </div>

        {/* Center: title */}
        <h1 className="text-lg font-semibold text-gray-900 dark:text-gray-100 whitespace-nowrap">
          Link Management
        </h1>

        {/* Right: user info + actions */}
        <div className="flex items-center justify-end gap-3 flex-1">
          {user && (
            <>
              <div className="hidden text-right lg:block">
                <p className="text-sm font-medium text-gray-900 dark:text-gray-100">{user.email}</p>
                <p className="text-xs text-gray-500 dark:text-gray-400">{user.roles.join(", ")}</p>
              </div>
              <ThemeToggle />
              <Button variant="ghost" size="icon" onClick={logout} title="Sign out">
                <LogOut className="h-4 w-4" />
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
